export const getServiceWorker = ({ serviceWorker }) => serviceWorker
